import { useState } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api, isMock } from '../api/client';
import { safeNext } from '../lib/auth';
import { AuthLayout } from '@bounded/ui/auth-layout';
import { Button, Field, Input } from '@bounded/ui/primitives';
import { ErrorNotice } from '@bounded/ui/state';
import { useT } from '../i18n';

export const Route = createFileRoute('/sign-in')({
  validateSearch: (search): { next?: string } => ({ next: safeNext(search.next) }),
  component: SignIn,
});

function SignIn() {
  const t = useT(); const m = t.auth;
  const { next } = Route.useSearch();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [email, setEmail] = useState(isMock ? 'ada@bounded.top' : '');
  const [password, setPassword] = useState('');
  const signIn = useMutation({
    mutationFn: () => api.signIn({ email, password }),
    // A fresh sign-in resets everything cached under the previous session (including its role).
    onSuccess: async () => { queryClient.clear(); await navigate({ href: next ?? '/' }); },
  });

  return (
    <AuthLayout title={m.title} footer={<p>{m.note}</p>}>
      <form className="grid gap-5" onSubmit={(e) => { e.preventDefault(); signIn.mutate(); }}>
        {signIn.error && <ErrorNotice error={signIn.error} onRetry={() => signIn.mutate()} />}
        <Field label={m.email} htmlFor="email"><Input id="email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} /></Field>
        <Field label={m.password} htmlFor="password" hint={isMock ? m.fixturesHint : undefined}>
          <Input id="password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        </Field>
        <Button type="submit" variant="primary" disabled={signIn.isPending}>{signIn.isPending ? m.submitting : m.submit}</Button>
      </form>
    </AuthLayout>
  );
}
